import React, { Component } from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
import Menu from "./components/Menu";
import Contact from './components/Contact';
import Navy from './components/Navy';
import Footer from './components/Footer';
import CallButton from './components/CallButton';

import './App.css';

class App extends Component {
  render() {
    return (
      <Router>
      <div className="App">
      
      <Navy/>
      <CallButton/>
          <Route exact path='/' component={Home}/>
          <Route path='/about' component={About}/> 
          <Route path='/menu' component={Menu}/>
          <Route path='/contact' component={Contact}/> 
          <Footer/>  
      </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js